import React from 'react';

const WhisperFrame: React.FC = () => {
  return (
    <iframe 
      title = "Whisper Frame"
      src="https://scribear.illinois.edu/v/whisper/" 
      style={{display: "none"}}
    />
  );
};

export default WhisperFrame;
